import React, { useState } from 'react'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { FormattedMessage, useIntl } from 'react-intl'
import Formsy from 'formsy-react'
import IconInputRow from 'app/components/input/IconInputRow'
import {
  TextInput,
  ButtonWithLoading,
} from 'app/components/FormsyHelperComponent'
import { Icon } from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'

export default (props) => {
  const { isOpen, onCancel, onValidSubmit, isPending } = props
  const [isFormValid, setIsFormValid] = useState()
  const onChange = () => {}
  const { formatMessage } = useIntl()

  return (
    <ResponsiveDialog
      open={isOpen}
      isFullScreen={false}
      scroll="paper"
      maxWidth="xs"
    >
      <DialogTitle>
        <FormattedMessage id="userMenu.changePassword.label" />
      </DialogTitle>
      <Formsy
        onChange={onChange}
        onValidSubmit={onValidSubmit}
        onValid={() => setIsFormValid(true)}
        onInvalid={() => setIsFormValid(false)}
        className="flex flex-col"
      >
        <DialogContent>
          <IconInputRow
            IconComponent={<Icon>lock</Icon>}
            Input={
              <TextInput
                type="password"
                maxLength={40}
                labelId="changePassword.placeholder.currentPassword"
                placeholderId="changePassword.placeholder.currentPassword"
                name="currentPassword"
                required
                fullWidth
                validations={{
                  minLength: 6,
                  checkWithNewPwd: (values, value) => {
                    return values.newPassword !== value
                  },
                }}
                validationErrors={{
                  checkWithNewPwd: formatMessage({
                    id: 'changePassword.validate.sameWithNewPassword',
                  }),
                  minLength: formatMessage({
                    id: 'login.textField.validation.minLengthPassword',
                  }),
                }}
              />
            }
          />
          <IconInputRow
            IconComponent={<Icon>lock</Icon>}
            Input={
              <TextInput
                type="password"
                labelId="changePassword.placeholder.newPassword"
                placeholderId="changePassword.placeholder.newPassword"
                name="newPassword"
                maxLength={40}
                required
                fullWidth
                validations={{
                  minLength: 6,
                  checkWithCurrentPwd: (values, value) => {
                    return values.currentPassword !== value
                  },
                }}
                validationErrors={{
                  checkWithCurrentPwd: formatMessage({
                    id: 'changePassword.validate.sameWithCurrentPassowrd',
                  }),
                  minLength: formatMessage({
                    id: 'login.textField.validation.minLengthPassword',
                  }),
                }}
              />
            }
          />
          <IconInputRow
            IconComponent={<Icon>lock</Icon>}
            Input={
              <TextInput
                type="password"
                containerClassName="flex-1"
                maxLength={40}
                labelId="changePassword.placeholder.confirmNewPassword"
                placeholderId="changePassword.placeholder.confirmNewPassword"
                name="confirmNewPassword"
                required
                fullWidth
                validations={{
                  minLength: 6,
                  checkWithCurrentPwd: (values, value) => {
                    return values.currentPassword !== value
                  },
                  checkWithConfirmation: (values, value) => {
                    return values.newPassword === value
                  },
                }}
                validationErrors={{
                  checkWithCurrentPwd: formatMessage({
                    id: 'changePassword.validate.sameWithCurrentPassowrd',
                  }),
                  checkWithConfirmation: formatMessage({
                    id: 'changePassword.validate.notSameWithConfirmation',
                  }),
                  minLength: formatMessage({
                    id: 'login.textField.validation.minLengthPassword',
                  }),
                }}
              />
            }
          />
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={onCancel} />
          <ButtonWithLoading
            isLoading={isPending || !isOpen}
            disabled={!isFormValid}
            type="submit"
          >
            <FormattedMessage id="saveBtn" />
          </ButtonWithLoading>
        </DialogActions>
      </Formsy>
    </ResponsiveDialog>
  )
}
